import { Component, OnInit } from '@angular/core';
import { VersionService } from '../../services/version.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss']
})
export class LogInComponent implements OnInit {
  versions: any[] = [];
  selectedVer: any= {};
  username: string;
  password: string;
  signinIn: boolean = false;
  success: boolean;

  constructor(private ver: VersionService, private router: Router) { }

  ngOnInit() {
    this.ver.get().subscribe(a => {
      this.versions = a;
      this.selectedVer = a[0];
    });
  }

  auth() {
    this.signinIn = true;
    this.ver.auth(this.selectedVer.id, this.username, this.password).subscribe( a => {
      console.log(a);
      if (a) {
        sessionStorage.setItem('versionId', this.selectedVer.id);
        this.router.navigate(['/']);
      }

      this.success = a;
      this.signinIn = false;
    }, b => {
      this.success = false;
      this.signinIn = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/log-in/log-in.component.ts